import React, {createContext, FC, useState} from "react";

// whether the widget dialog is open
export const dialogOpenContext = createContext<
  [boolean, React.Dispatch<boolean>]
>([false, () => null!]);

export const DialogOpenContextProvider: FC = ({ children }) => {
  const dialogState = useState(false);
  return (
    <dialogOpenContext.Provider value={dialogState}>
      {children}
    </dialogOpenContext.Provider>
  );
};
